import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  tags: [],
  search: "",
  author: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    tagSelected: (state, action) => {
      state.tags.push(action.payload);
    },
    tagRemoved: (state, action) => {
      const isExists = state.tags.indexOf(action.payload);
      if (isExists !== -1) {
        state.tags.splice(isExists, 1);
      }
    },
    isSearched: (state, action) => {
      state.search = action.payload;
    },
    authorFilter: (state, action) => {
      console.log(action);
      state.author = action.payload;
    },
    clearAll: (state) => {
      state.search = "";
      state.author = "";
      state.tags = [];
    },
  },
});

export const { tagSelected, tagRemoved, isSearched, clearAll, authorFilter } =
  filterSlice.actions;
export default filterSlice.reducer;
